var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-col',[_c('p',{staticClass:"text-uppercase font-weight-bold deviceWarningTitle",class:[_vm.isAlert ? 'text-danger': '']},[_vm._v(_vm._s(_vm.$t(_vm.chartTitle)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }